import Lang from "@vendors-fr/messages";
import 'jquery-match-height';
import {changeCartNum, getCartAjaxUrl, refreshSelectorSyncSpan, setCartItem} from '@plugins-fr/script';
import { waca } from '@plugins-fr/regExp';
import {DialogMessage} from "@plugins-fr/dialogMessage";
import {keenSliderBuilder} from "@commons-fr/keenSliderBuilder";
import {featurePromotionN} from "@commons-fr/userStatus";
import {PushAds} from "@commons-fr/pushAds";
import {UserStatusService} from "@commons-fr/userStatusService";
import {expiredPromotionNotify} from "@commons-fr/login";
import {productOnSalePrice} from "@commons-fr/productOnSalePrice";
import {promotionsNPage} from "@commons/userTracks/viewActionName";
import {recordUserEventTrack, recordUserViewTrack} from "@commons/userTracks/userTrack";
import {promotionNPageAddToCart, promotionNPageDeleteCartItem} from "@commons/userTracks/eventActionName";

$(function() {
    var totalBlock = $("#js_sticker");
    var pos = $("#js_sticker").offset().top;
    var hei = totalBlock.parent().outerHeight();

    if ( $(window).width() > 991 ) {
        var windowpos = $(window).scrollTop();
        if ( windowpos <= pos ) {
            totalBlock.removeClass("stick");
        } else {
            totalBlock.parent().css("height", hei);
            totalBlock.addClass("stick");
        }
        //捲動間隔0.03秒
        $(window).scroll(function() {
            if(this.scrollTO) clearTimeout(this.scrollTO);
            this.scrollTO = setTimeout(function() {
                $(this).trigger('scrollEnd');
            }, 30);
        });
        $(window).bind('scrollEnd', function() {
            var windowpos = $(window).scrollTop();
            scroll_pos();
            if( $(window).width() < 992 ) {
                return false;
            }
        });
    } else {
        totalBlock.addClass("stick");
    }
    //scroll時判斷position
    function scroll_pos() {
        var windowpos = $(window).scrollTop();
        if( $(window).width() > 991 ) {
            if ( windowpos <= pos ) {
                totalBlock.removeClass("stick");
                // totalBlock.parent().css("height", "");
            } else {
                // totalBlock.parent().css("height", hei);
                totalBlock.addClass("stick");
            }
        }
        else {
            // totalBlock.parent().css("height", "");
        }
    }
    //判斷目前視窗
    function resize_win() {
        if ( $(window).width() < 992 ) {
            totalBlock.addClass("stick");
        }
        else {
            totalBlock.removeClass("stick");
            //捲動間隔0.03秒
            $(window).scroll(function() {
                if(this.scrollTO) clearTimeout(this.scrollTO);
                this.scrollTO = setTimeout(function() {
                    $(this).trigger('scrollEnd');
                }, 30);
            });
            $(window).bind('scrollEnd', function() {
                var windowpos = $(window).scrollTop();
                scroll_pos();
            });
        }
    }
    //視窗縮放間隔0.5秒
    var stickerHeight;
    function computedIconOffset() {
        setTimeout(function() {
            if( $(window).width() < 992 ) {
                stickerHeight = $('#js_sticker').outerHeight() + $('.js_chose_area').outerHeight();

                $('#js_contactus_inner').css('bottom', stickerHeight + 10);
                $('.layout_footer').height(stickerHeight);

                if( $(window).width() > 767 ) {
                    $('.layout_footer').height(78);
                }
            } else {
                $('#js_contactus_inner').css('bottom', '');
                $('.layout_footer').height('');
            }
        }, 500);
    }
    computedIconOffset();

    //視窗縮放間隔0.5秒
    $(window).resize(function() {
        if(this.resizeTO) clearTimeout(this.resizeTO);
        this.resizeTO = setTimeout(function() {
            $(this).trigger('resizeEnd');
        }, 500);

        computedIconOffset();
    });
    $(window).bind('resizeEnd', function() {
        resize_win();
    });
    //手機選購區

    $(".js_chose_area").on("click", function() {
        var max_h = $(window).height() - $("#js_sticker").height() - 100;
        $("#js_mask_cover").toggleClass("is-active");
        if ($("#js_mask_cover").hasClass("is-active")) {
            $('#js_sticker').css("z-index", 1060);
        } else {
            $('#js_sticker').css("z-index", 1030);
        }
        if ( $(".js_promTotal_cont").is(":visible") ) {
            $(".js_open_pop").click();
        }

        if ($(".js_chose_list li").length == 0 ) {
            $(".js_chose_list").html('<li class="cart_empty js_cart_empty"><i class="icon-new_nocart"></i><span>購物車內無任何商品！</span></li>')
        }

        if ( $(".js_chose_list").is(":visible") ) {
            // run_footerBtn = true;
            $("body").css({"overflow": ""});
            totalBlock.css("z-index", ""); //behind the left-menu
            $(".js_chose_list").addClass('d-none');
            $(".js_chose_icon").removeClass("icon-triangle-down").addClass("icon-triangle-up");
            $(".js_promotions_condition_txt").removeClass("line2");
        }
        else {
            // run_footerBtn = false;
            $("body").css({"overflow": "hidden"});
            // totalBlock.css("z-index", 101);
            $(".js_chose_list").removeClass('d-none');
            $(".js_chose_list").css( "max-height", max_h ).show();
            $(".js_chose_icon").removeClass("icon-triangle-up").addClass("icon-triangle-down");
            $(".js_promotions_condition_txt").addClass("line2");
        }
    });

    $(".js_open_pop").on("click", function() {
        var max_h = $(window).height() - $("#js_sticker").height() - 100;

        if ( $(".js_chose_list").is(":visible") ) {
            $(".js_chose_area").click();
        }

        if( $(".js_promTotal_cont").is(':visible') ) {
            $("body").css({"overflow": ""});
        } else {
            $("body").css({"overflow": "hidden"});
        }

        $("#js_mask_cover").toggleClass("is-active");
        if ($("#js_mask_cover").hasClass("is-active")) {
            $('#js_sticker').css("z-index", 1060);
        } else {
            $('#js_sticker').css("z-index", 1030);
        }
        $(".js_promTotal_cont").css( "max-height", max_h ).toggleClass("d-none");
        $(".js_chose_icon").toggleClass("icon-triangle-up icon-triangle-down");
        $(this).toggleClass('active');
        $(".js_promTotal_icon").toggleClass("icon-keyboard_arrow_up icon-keyboard_arrow_right");
        $(".js_promotions_condition_txt").toggleClass("line2");

        var text = $('.js_pop_tit').data('text');
        $('.js_pop_tit').data('text', text == 'tit_selected' ? 'tit_discount' : 'tit_selected').text(text == 'tit_selected' ? Lang.get('frontend.promotion.chose.discount') :  Lang.get('frontend.promotion.chose.item'));
    });

    // $("#js_mask_cover").on("click", function() {
    //     run_footerBtn = true;
    // });

    var chosenItems = {
        init: function () {
            var self = this;
            self._initKeenSlider();

            $('.js_matchheight').matchHeight();
            $('.js_item_name_matchheight').matchHeight();
        },
        getItems: function (standardId) {
            return this._getChosenAreas().find('.js_select_item[data-standard-id="'+standardId+'"]');
        },
        hasItem: function (standardId) {
            var items = this.getItems(standardId);
            return items.length > 0;
        },
        updateQuantity: function (standardId, quantity) {
            var items = this.getItems(standardId);
            items.find('.js_select_item_quantity').text(quantity);
        },
        addOrUpdateItemByItemBlock: function (itemBlock) {
            var product_id = itemBlockHelper.getSelectedProductId(itemBlock);
            var standard_id = itemBlockHelper.getSelectedStandardId(itemBlock);
            var imageId = getStandardsInfo(product_id, standard_id, 'imageId');

            const qty = selectedItems.getStandard(standard_id);

            // update 數量
            if (this.hasItem(standard_id)) {
                this.updateQuantity(standard_id, qty);
                return;
            }

            let standardPrice = getStandardsInfo(product_id, standard_id, 'realPrice').toString().replace(',', '');
            if (productOnSalePrice.getIsVisibleOnSaleMemberStyle()) {
                standardPrice = getStandardsInfo(product_id, standard_id, 'price').toString().replace(',', '');
            }

            this._addItem({
                productId: product_id,
                standardId: standard_id,
                price: standardPrice,
                image: getImageUrl(imageId),
                smallImage: getSmallImageUrl(imageId),
                isPreOrder: getStandardsInfo(product_id, 0, 'is_pre_order'),
                name: itemBlock.find(".js_item_name").text(),
                main: getStandardsInfo(product_id, standard_id, 'main'),
                sub: getStandardsInfo(product_id, standard_id, 'sub'),
                quantity: qty
            });
        },
        addOrUpdateItemByCart: function (owlItem) {
            this._addItem({
                productId: owlItem.productId,
                standardId: owlItem.standardId,
                price: owlItem.price,
                image: owlItem.imageUrl,
                smallImage: owlItem.smallImageUrl,
                isPreOrder: owlItem.isPreOrder,
                name: owlItem.name,
                main: owlItem.main,
                sub: owlItem.sub,
                quantity: owlItem.quantity,
            });
        },
        _addItem: function (item) {
            var html = $(this._getWebHtml());
            html.attr('data-product-id', item.productId);
            html.attr('data-standard-id', item.standardId);
            html.attr('data-price', item.price);
            html.find('.js_select_photo').css('background-image', item.image ? 'url(' + item.image + ')' : 'none');
            html.find('.js_select_pre_order').css('display', parseInt(item.isPreOrder) ? 'block' : 'none');
            html.find('.js_select_product_name').text(item.name);
            html.find('.js_select_standard_main').text(item.main);
            html.find('.js_select_standard_sub').text(item.sub);
            html.find('.js_select_item_quantity').text(item.quantity);
            html = html[0].outerHTML;
            this._getCarouselAreas().each(function () {
                var slider = $(this).data('keenSlider');
                $(this).append(html)
                slider.update();
            });

            html = $(this._getMobileHtml());
            html.attr('data-product-id', item.productId);
            html.attr('data-standard-id', item.standardId);
            html.attr('data-price', item.price);
            html.find('.js_select_photo_mobile').attr('src', item.smallImage ? item.smallImage : '');
            html.find('.js_select_pre_order').css('display', parseInt(item.isPreOrder) ? 'inline-block' : 'none');
            html.find('.js_select_product_name').text(item.name);
            // html.find('.js_select_standard_main').text(item.main);
            html.find('.js_select_item_quantity').text(item.quantity);
            $('.js_chose_list').append(html);
            $('.js_item_name_matchheight').matchHeight();
        },
        _initKeenSlider: function () {
            const builder = new keenSliderBuilder();
            this._getCarouselAreas().each(function () {
                let slider = builder.init(this, {
                    breakpoints: {
                        "(min-width: 992px)": {
                            slides: {
                                perView: 4,
                                spacing: 20
                            },
                        },
                        "(min-width: 1200px)": {
                            slides: {
                                perView: 5,
                                spacing: 20
                            },
                        }
                    }
                });

                $(this).data('keenSlider', slider);
            });
        },
        _getChosenAreas: function() {
            return $('.js_chose_list, #js_promotion_top, #js_promotion_bottom');
        },
        _getCarouselAreas: function () {
            return $("#js_promotion_top, #js_promotion_bottom");
        },
        _getWebHtml: function () {
            return owlHtml.web;
        },
        _getMobileHtml: function () {
            return owlHtml.mobile;
        }
    };
    chosenItems.init();

    var quantity = 0;           // 已選取商品數量
    var sum = 0;                // 已選取商品總價

    var itemBlockPool = {
        data: {},
        has: function(productId) {
            return this.data[productId] !== undefined;
        },
        put: function (productId, element) {
            this.data[productId] = element;
        },
        get: function(productId) {
            if (undefined === this.data[productId]) {
                this.put(productId, $(".js_item_block[data-product-id = '"+ productId +"']"));
            }
            return this.data[productId];
        },
    };

    var itemBlockHelper = {
        getSelectedOption: function (itemBlock) {
            return itemBlock.find(".js_standard option:selected");
        },
        getSelectedProductId: function (itemBlock) {
            return parseInt(itemBlock.attr('data-product-id'));
        },
        getSelectedStandardId: function (itemBlock) {
            return parseInt(this.getSelectedOption(itemBlock).val());
        },
        getSelectedQuantity: function (itemBlock) {
            return parseInt(itemBlock.find(".js_promotion_qty .js_product_qty").val());
        }
    };

    const selectedItems = {
        data: {},
        add: function (standardId, quantity) {
            if (!this.data[standardId]) {
                this.data[standardId] = 0;
            }
            this.data[standardId] = quantity;
        },
        remove: function (standardId) {
            delete this.data[standardId];
        },
        getAll: function () {
            return this.data;
        },
        getStandard: function (standardId) {
            return this.data[standardId];
        },
    };

    // 商品是否已被選取
    var isProductChosen = function(standard_id) {
        return typeof selectedItems.getStandard(standard_id) !== 'undefined';
    };

    var hasAnyChosenProducts = function () {
        return Object.keys(selectedItems).length > 0;
    };

    var dialogError = function(message) {
        new DialogMessage({
            'title': message,
        }).handle();
    };

    // 檢查是否已存在被選取商品
    var handleSliderDisplay = function () {
        if (hasAnyChosenProducts()) {
            $('.js_mobile_chose_area').slideDown();
            $(".js_cart_empty").addClass('d-none');
            $('body').addClass("fixed_move_top").removeClass("fixed_move_bot");
        } else {
            if ($("#js_mask_cover").hasClass("is-active")) {
                $('.js_chose_area').click();
            }
            $(".js_cart_empty").removeClass('d-none');
            $('body').addClass("fixed_move_bot").removeClass("fixed_move_top");
        }
    };

    // 根據商品庫存更動可選購商品的最大數量
    var handleQtyAndBuyButton = function (product_id) {
        var itemBlock = itemBlockPool.get(product_id);
        var selectedOption = itemBlockHelper.getSelectedOption(itemBlock);
        var standard_id = parseInt(selectedOption.val());
        var soldout_element = itemBlock.find(".js_item_soldout");
        var outofstock_element = itemBlock.find(".js_item_outofstock");
        var qty_element = itemBlock.find(".js_promotion_qty");
        var btn_select_element = itemBlock.find(".js_btn_select");

        var stock = getStandardsInfo(product_id, standard_id, 'stock');
        var has_stock = getStandardsInfo(product_id, standard_id, 'hasStock');

        // priceByStandard
        // qty_element.parent().css('visibility', standard_id > 0 ? 'visible' : 'hidden');
        stock = standard_id > 0 ? stock : '1_1';
        has_stock = standard_id > 0 ? has_stock : 'ok';

        if (has_stock !== 'ok') {
            if (has_stock === 'out_of_stock') {
                outofstock_element.removeClass('d-none');
                btn_select_element.addClass('d-none');
                soldout_element.addClass('d-none');
                qty_element.addClass('d-none').removeClass('d-flex');
            } else {
                soldout_element.removeClass('d-none');
                btn_select_element.addClass('d-none');
                outofstock_element.addClass('d-none');
                qty_element.addClass('d-none').removeClass('d-flex');
            }
        } else {
            outofstock_element.addClass('d-none');
            soldout_element.addClass('d-none');
            btn_select_element.removeClass('d-none');
            qty_element.removeClass('d-none');

            var stocks = stock.split('_');
            stocks[0] = parseInt(stocks[0]);
            stocks[1] = parseInt(stocks[1]);

            qty_element.find('.js_product_qty').data('min', stocks[0]);
            qty_element.find('.js_product_qty').data('max', stocks[1]);
        }
    };

    // 勾選已選取時動作
    var chooseItem = function(product_id){
        var itemBlock = itemBlockPool.get(product_id);
        var standard_id = itemBlockHelper.getSelectedStandardId(itemBlock);

        if (standard_id === 0) {
            dialogError(Lang.get('frontend.product.title.plz.selectstyle'));
            return;
        }
        if(isProductChosen(standard_id)) return;

        var qty = itemBlockHelper.getSelectedQuantity(itemBlock);
        var params = {
            product_id : product_id,
            standard_id : standard_id,
            qty : qty
        };
        const action = 'add_cart_item';
        setCartItem(action, params, function(data){
            if (typeof data.cart_trace != 'undefined') {
                $('#addtocart').remove();
                var script  = document.createElement("script");
                script.id = 'addtocart';
                script.innerHTML = data.cart_trace;
                document.body.appendChild(script);
            }

            if (typeof data != 'undefined' && typeof data.status != 'undefined' && ! data.status) {
                dialogError(data.message);
            } else {
                recordUserEventTrack(promotionNPageAddToCart, getCartAjaxUrl(action), {
                    'product_id': Number(params.product_id),
                    'standard_id': Number(params.standard_id),
                    'quantity': Number(params.qty),
                });
                changeCartNum(data.cart_number);
                selectedItems.add(standard_id, qty);
                changeBuyButton(product_id, 'add');
                chosenItems.addOrUpdateItemByItemBlock(itemBlock);
                handleSlogan();
                handleSliderDisplay();
            }
        });

    };

    /**
     * 選購按鍵樣式更替
     */
    var changeBuyButton = function(product_id, action) {
        var itemBlock = itemBlockPool.get(product_id);
        var btn_select_element = itemBlock.find(".js_btn_select");
        var btn_text_element = btn_select_element.find('span');

        if(action == 'add') {
            itemBlock.addClass('active');
            btn_select_element.removeClass('btn_noselect').addClass('btn_select');
            btn_text_element.text(Lang.get('frontend.promotion.btn.choose'))
            btn_select_element.attr('style', btn_select_element.data('selected-style'));
            itemBlock.attr('style', itemBlock.data('active-style'));
        } else {
            itemBlock.removeClass('active');
            btn_select_element.removeClass('btn_select').addClass('btn_noselect');
            btn_text_element.text(Lang.get('frontend.promotion.btn.purchase'));
            btn_select_element.attr('style', btn_select_element.data('unselect-style'));
            itemBlock.attr('style', '');
        }
    };

    // 檢查商品是否已選購並做出對應行為
    var handleInCartProductDisplay = function(product_id) {
        var itemBlock = itemBlockPool.get(product_id);
        var qty_element = itemBlock.find(".js_promotion_qty");
        var standard_id = itemBlockHelper.getSelectedStandardId(itemBlock);

        if(isProductChosen(standard_id)) {
            changeBuyButton(product_id, 'add');
            qty_element.find('.js_product_qty').val(selectedItems.getStandard(standard_id));
        } else {
            changeBuyButton(product_id, 'remove');

            var productQtyElement = qty_element.find('.js_product_qty');
            productQtyElement.val(productQtyElement.data('min'));
        }
    };

    // 商品數量 +- 按鈕顯示
    var handleQtyMinusAndPlusButton = function (productId){
        var itemBlock = itemBlockPool.get(productId);
        var qtyElement = itemBlock.find(".js_promotion_qty");
        var productQtyElement = qtyElement.find('.js_product_qty');
        var qtyPlusElement = qtyElement.find('.js_qty_plus');
        var qtyMinusElement = qtyElement.find('.js_qty_minus');
        var qty = productQtyElement.val();
        var minQty = productQtyElement.data('min');
        var maxQty = productQtyElement.data('max');

        if (qty > minQty) {
            qtyMinusElement.prop('disabled', false);
        } else {
            qtyMinusElement.prop('disabled', true);
        }

        if (qty < maxQty) {
            qtyPlusElement.prop('disabled', false);
        } else {
            qtyPlusElement.prop('disabled', true);
        }
    };

    // 計算已選購商品總量與總價
    var calcTotal = function() {
        sum=0;
        quantity = 0;

        const products = selectedItems.getAll();

        $.each(products, function (standardId, qty) {
            const item = $(".js_select_item[data-standard-id = '" + standardId + "']");
            quantity += parseInt(qty);
            sum += (item.attr('data-price')) * parseInt(qty);
        });
    };

    // 更動已選購商品數量時動作
    var changeQty = function(product_id) {
        var itemBlock = itemBlockPool.get(product_id);
        var qtyElm = itemBlock.find(".js_promotion_qty .js_product_qty");
        var standard_id = itemBlockHelper.getSelectedStandardId(itemBlock);

        if (!isProductChosen(standard_id)) return;

        var qty = qtyElm.val();
        var min = qtyElm.data('min');
        var max = qtyElm.data('max');
        if (! waca.regexValidator.number(qty) || qty < min) {
            qty = min;
        } else if (qty > max) {
            qty = max;
        }

        var params = {
            product_id : product_id,
            standard_id : standard_id,
            qty : qty
        };
        setCartItem('update_cart_item', params, function(data){
            if (typeof data != 'undefined' && typeof data.status != 'undefined' && ! data.status) {
                dialogError(data.message);
            } else {
                changeCartNum(data.cart_number);
                selectedItems.add(standard_id, qty);
                chosenItems.addOrUpdateItemByItemBlock(itemBlock);
                handleSlogan();
            }
        });
    };

    // 更改已選購商品 總數/總價 顯示文字
    var changePromotionNum = function() {
        var check_condition_num = promotion_condition.condition == 'quantity' ? quantity : sum,
            slogan = '',
            condition_diff = '';

        $(".js_promotion_num").text(check_condition_num);

        $.each(promotion_condition.exchangeRateSetting, function(key,val){
            slogan = val.slogan;
            if (check_condition_num < val.condition_number ) {
                condition_diff = val.condition_number - check_condition_num;
                if (promotion_condition.condition == 'quantity' || shops_currency_decimals === 0) {
                    condition_diff = condition_diff.toFixed(0);
                } else {
                    condition_diff = condition_diff.toFixed(2);
                }
                slogan = val.condition_slogan;
                return false;
            }
        });

        $('.js_promotions_condition_txt').html(slogan);
        $('.js_selected_txt').html('<div class="d-none d-sm-block">' + Lang.get('frontend.promotion.btn.'+promotion_condition.condition+'.chooseNumber', {'icon': icon, 'number': '<b class="red">'+check_condition_num+'</b>', 'unit': unit}) + '</div>');

        if (condition_diff != '') {
            $('.js_promotions_condition_txt .js_promotion_condition').html(condition_diff);
        }
    };

    $('.js_open_bar').on('click', function(){
        var elm = $(this).closest('.js_open_bar');
        elm.toggleClass('open');
        elm.find('.more_btn').find('i').toggleClass('icon-keyboard_arrow_down icon-keyboard_arrow_right');
        $('.js_promTotal_cont').toggleClass('d-none');
    });

    var handleStandardImage = function (product_id) {
        var itemBlock = itemBlockPool.get(product_id);
        var standardId = itemBlockHelper.getSelectedStandardId(itemBlock);

        var imageId = getStandardsInfo(product_id, standardId, 'imageId');
        var smallImageUrl = getSmallImageUrl(imageId);
        var imageUrl = getImageUrl(imageId);

        itemBlock.find('span.js_item_photo').attr('data-small-img', smallImageUrl);
        itemBlock.find('span.js_item_photo').css('background-image', imageUrl ? 'url('+imageUrl+')' : 'none');
    };

    // priceByStandard
    var handleStandardPrice = function (product_id) {
        var itemBlock = itemBlockPool.get(product_id);
        var standardId = itemBlockHelper.getSelectedStandardId(itemBlock);
        var displayBothPrices = getStandardsInfo(product_id, standardId, 'displayBothPrices');
        var price = getStandardsInfo(product_id, standardId, 'price');
        var realPrice = getStandardsInfo(product_id, standardId, 'realPrice');

        if (displayBothPrices) {
            itemBlock.find('.js_forsale_price').addClass('d-none').removeClass('d-flex flex-column');
            itemBlock.find('.js_onsale_price').removeClass('d-none').addClass('d-flex flex-column');
        } else {
            itemBlock.find('.js_forsale_price').removeClass('d-none').addClass('d-flex flex-column');
            itemBlock.find('.js_onsale_price').addClass('d-none').removeClass('d-flex flex-column');
        }
        itemBlock.find('.js_price_span').text(price);
        itemBlock.find('.js_onsale_price_span').text(realPrice);
    };

    //移除slides內的商品
    var removeItem = function (selectedItemBlock) {
        var product_id = parseInt(selectedItemBlock.attr('data-product-id'));
        var standard_id = parseInt(selectedItemBlock.attr('data-standard-id'));
        var quantity = parseInt(selectedItemBlock.find('.js_select_item_quantity').text());

        chosenItems.getItems(standard_id).each(function () {
            // 移除桌機版的已選購區
            chosenItems._getCarouselAreas().each(function () {
                $(this).find('.js_select_item[data-standard-id="'+standard_id+'"]').remove();
                var slider = $(this).data('keenSlider');
                slider.update();
            });

            // 移除手機版的已選購區
            $('.js_chose_list').find('.js_select_item[data-standard-id="'+standard_id+'"]').remove();
    });

        selectedItemBlock.remove();

        var params = {
            product_id : product_id,
            standard_id : standard_id,
            qty : quantity
        };
        const action = 'remove_cart_item';
        setCartItem(action, params, function(data){
            if (typeof data.cart_trace != 'undefined') {
                $('#addtocart').remove();
                var script  = document.createElement("script");
                script.id = 'addtocart';
                script.innerHTML = data.cart_trace;
                document.body.appendChild(script);
            }

            if (typeof data != 'undefined' && typeof data.status != 'undefined' && ! data.status) {
                dialogError(data.message);
            } else {
                recordUserEventTrack(promotionNPageDeleteCartItem, getCartAjaxUrl(action), {
                    'product_id': Number(params.product_id),
                    'standard_id': Number(params.standard_id),
                    'quantity': Number(params.qty),
                });
                changeCartNum(data.cart_number);
                selectedItems.remove(standard_id);
                changeBuyButton(product_id, 'remove');
                handleSlogan();
                handleSliderDisplay();
            }
        });
    };

    // 檢查已選購商品是否符合活動條件, 符合即可結帳
    var handleSlogan = function(){

        calcTotal();

        var check_condition_num = promotion_condition.condition == 'quantity' ? quantity : sum,
            isMeetCondition = false;

        $.each(promotion_condition.exchangeRateSetting, function(key,val){
            if (check_condition_num >= val.condition_number ) {
                isMeetCondition = true;
                return false;
            }
        });

        if(isMeetCondition) {
            $('.js_btn_gopay span').text(Lang.get('frontend.cart.btn.goshopping'));
            $('.js_btn_gopay').attr('disabled', false).removeClass('d-none');
            $('.js_btn_gopay').attr('style', $('.js_btn_gopay').data('style'))
        } else {
            $('.js_btn_gopay span').text(Lang.get('frontend.cart.tags.promotions.substandard'));
            $('.js_btn_gopay').attr('disabled', true).removeClass('d-none');
            $('.js_btn_gopay').attr('style', $('.js_btn_gopay').data('substandard-style'))
        }

        changePromotionNum();
    };



    // 進入頁面初始設定
    var syncProducts = function () {

        $('.js_item_block').each(function () {
            const itemBlock = $(this);
            const productId = itemBlock.attr('data-product-id');
            if (!itemBlockPool.has(productId)) {
                itemBlockPool.put(productId, itemBlock);
            }
            handleQtyAndBuyButton(productId);
            handleStandardPrice(productId);
            handleInCartProductDisplay(productId);
            handleQtyMinusAndPlusButton(productId);
        });
        refreshSelectorSyncSpan();
    };

    syncProducts();
    handleSlogan();
    handleSliderDisplay();

    // 規格更動
    $('.js_onsale').on('change', ".js_standard", function(){
        var product_id = $(this).parents('.js_item_block').attr('data-product-id');

        handleStandardImage(product_id);
        handleQtyAndBuyButton(product_id);
        handleStandardPrice(product_id);
        handleInCartProductDisplay(product_id);
        handleQtyMinusAndPlusButton(product_id);
        refreshSelectorSyncSpan();
    });

    // 選購
    $('.js_onsale').on('click', ".js_btn_select", function(){
        var product_id = $(this).parents('.js_item_block').attr('data-product-id');
        chooseItem(product_id);
        return false;
    });

    // 更動選購商品數量
    $('.js_onsale').on('change', '.js_product_qty', function(){
        var product_id = $(this).parents('.js_item_block').attr('data-product-id');
        changeQty(product_id);
    });

    // 移除已選購商品
    $('.keen-slider, .js_chose_list').on('click', '.js_select_del', function(event){
        event.preventDefault();
        var selectItemBlock = $(this).parents('.js_select_item');
        removeItem(selectItemBlock);
        return false;
    });

    // 前往結帳
    $('.js_btn_gopay').on('click', function(){
        if (!website_type.display_promotion) {
            location.href = locale + '/';
        } else {
            location.href = locale + '/cart';
        }
        return false;
    });

    // 購物車連動
    var cart_number = $('.js_cart_number').text();
    $("#js_mask_cover").click(function(){
        if (cart_number != $('.js_cart_number').text()) {
            // location.reload();
        }
        if ( $(".js_promTotal_cont").is(":visible") ) {
            $(".js_open_pop").click();
            $(this).removeClass('is-active');
        }
        $("body").css("overflow", "");
        totalBlock.css("z-index", "");
        $(".js_chose_list").addClass('d-none');
        $(".js_chose_icon").removeClass("icon-triangle-down").addClass("icon-triangle-up");
    });

    var has_product = true;
    var lock = false;
    var page = 2;
    var productsArea = $('#promotion_product_list');
    var scrollTimer = null;
    // 取得商品資料
    $('.bottom_cart').hide();
    $(window).scroll(function() {
        if (!has_product || lock) {
            return false;
        }
        if (scrollTimer) {
            clearTimeout(scrollTimer);
        }

        scrollTimer = setTimeout(function() {
            if ($(window).scrollTop() >= productsArea.height() - $(window).height() * 2.5) {
                lock = true;
                $.ajax({
                    url: url_promotion_products_ajax,
                    type: 'GET',
                    data: {page: page},
                    dataType: 'json',
                    success: function (response) {
                        if (!response.status) {
                            has_product = false;
                            $('.bottom_cart').fadeIn(1);
                            return;
                        }

                        // merge standards & images
                        $.extend(standards, response.standards);
                        $.extend(imageUrls, response.imageUrls);

                        productsArea.append(response.view);
                        syncProducts();
                        $('.js_matchheight').matchHeight();
                        $('.js_item_name_matchheight').matchHeight();
                        lock = false;
                        page++;
                    }
                });
            }
        }, 10);
    });

    function getSmallImageUrl(imageId) {
        if (typeof imageUrls[imageId] === 'undefined') {
            return ''
        }
        return imageUrls[imageId].smallImageUrl;
    }

    function getImageUrl(imageId) {
        if (typeof imageUrls[imageId] === 'undefined') {
            return ''
        }
        return imageUrls[imageId].imageUrl;
    }

    function getStandardsInfo(productId, standardId, key) {
        var value = null;
        try {
            value = standards[productId][standardId][key];
        } catch (e) {
            console.error(e);
        }
        return value;
    }

    const uss = new UserStatusService();
    uss.registerFeature(featurePromotionN, {'promotionId': owlPromotionId}, function(response){
        // 活動過期/不符合會員資格
        if (!response) {
            expiredPromotionNotify();
            return;
        }

        $.each(response.cartPromotionProducts, function (key, owlItem) {
            selectedItems.add(owlItem.standardId, owlItem.quantity);
            // itemBlockHelper.setSelectedOption(itemBlockPool.get(owlItem.productId), owlItem.standardId);
            chosenItems.addOrUpdateItemByCart(owlItem);
        });

        chosenItems.init();
        syncProducts();
        handleSlogan();
        handleSliderDisplay();
    });

    uss.setCallback(function(result){
        productOnSalePrice.visiblePromotionList(document.querySelector('#promotion_product_list'));
        (new PushAds()).start();
        recordUserViewTrack(promotionsNPage, '', {
            'promotion_id': parseInt(owlPromotionId),
        });
    });
});
